"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAvailablityLabel;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getAvailablityLabel(bookablePeriods, T, formatDate) {
  if (!bookablePeriods.length) {
    return T('Unavailable');
  }

  var startDate = bookablePeriods[0].from;
  var endDate = bookablePeriods[0].to;
  var start = formatDate('D MMM YYYY', startDate);
  var end = formatDate('D MMM YYYY', endDate);

  if ((0, _dayjs["default"])().isAfter(startDate) && (0, _dayjs["default"])().isBefore(endDate)) {
    start = T('Now');
  }

  if ((0, _dayjs["default"])(endDate).isSame(_constants.NO_END)) {
    end = T('Unlimited');
  }

  return start + " - " + end;
}